"use client";

import { FOOTER_DOG_EYES as EYES } from "@/app/(public)/shared/_logic/constants";
import dog from "@/app/(public)/shared/assets/nowadays-dog-eyeless.png";
import { useLookAtCursor } from "@/app/(public)/shared/hooks/useLookAtCursor";
import { cn } from "@/lib/utils/index";
import { motion } from "motion/react";
import Image from "next/image";
import { useRef } from "react";

interface LookingDogProps {
  className?: string;
  sizes: string;
}

/**
 * The party-hat Nowadays dog, its eyes following the cursor.
 *
 * @param props - {@link LookingDogProps}.
 * @returns The dog with its pupils drawn over it.
 */
export const LookingDog = ({ className, sizes }: LookingDogProps) => {
  // Hooks
  const dogRef = useRef<HTMLDivElement>(null);
  const gaze = useLookAtCursor(dogRef, EYES.look);

  // Render
  return (
    <div ref={dogRef} className={cn("relative", className)}>
      <Image src={dog} alt="The Nowadays dog in a party hat" sizes={sizes} className="block w-full h-auto" />
      {EYES.centers.map((center) => (
        <motion.span
          key={`${center.x}-${center.y}`}
          aria-hidden="true"
          className="absolute rounded-[50%]"
          style={{
            left: `${(center.x - EYES.pupil.width / 2) * 100}%`,
            top: `${(center.y - EYES.pupil.height / 2) * 100}%`,
            width: `${EYES.pupil.width * 100}%`,
            height: `${EYES.pupil.height * 100}%`,
            x: gaze.x,
            y: gaze.y,
            backgroundColor: EYES.color,
          }}
        />
      ))}
    </div>
  );
};
